import { useAPI } from "../../hooks/useAPI";

import { ENDPOINTS } from "../../constants/endpoints.constant";
import { getCall } from "../../constants/apicalls.constant";

import { RegisteredUser } from "../../models/registration";

import RegistrationTable from "./table.registration";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useMemo, useState } from "react";

const RegistrationDetails = ({ id }: { id: string }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState<string | undefined>(undefined);
  const [filters, setFilters] = useState<{
    quantity?: number;
    ticket_id?: string;
    payment_method?: string;
    email?: string;
    subtotal?: string | number;
    gender?: string;
    tshirt_size?: string;
    blood_group?: string;
    nationality?: string;
    city?: string;
    country?: string;
  }>({});

  const event = useSelector((state: RootState) => state.event);
  const ticketOptions = useMemo(() => {
    return (
      event?.tickets
        ?.filter((t: any) => t.id && t.name)
        .map(({ name, id }: any) => ({
          label: name,
          value: id,
        })) || []
    );
  }, [event, id]);

  const buildFilters = () => {
    const apiFilters: Record<string, unknown> = {
      "order.event_id": {
        eq: id,
      },
      status: {
        in: ["placed", "refunded"],
      },
    };

    if (filters.quantity) {
      apiFilters["available_quantity"] = { $eq: filters.quantity };
    }
    if (filters.ticket_id) {
      apiFilters["ticket_id"] = { $eq: filters.ticket_id };
    }
    if (filters.payment_method) {
      apiFilters["order.payment_method"] = { $eq: filters.payment_method };
    }
    if (filters.email) {
      apiFilters["email"] = { lk: `%${filters.email}%` };
    }
    if (filters.subtotal) {
      apiFilters["subtotal"] = { $eq: filters.subtotal };
    }
    if (filters.gender) {
      apiFilters["RegistrationFormResponse.gender"] = { eq: filters.gender };
    }
    if (filters.tshirt_size) {
      apiFilters["RegistrationFormResponse.tshirt_size"] = {
        eq: filters.tshirt_size,
      };
    }
    if (filters.blood_group) {
      apiFilters["RegistrationFormResponse.blood_group"] = {
        eq: filters.blood_group,
      };
    }
    if (filters.nationality) {
      apiFilters["RegistrationFormResponse.nationality"] = {
        lk: `%${filters.nationality}%`,
      };
    }
    if (filters.city) {
      apiFilters["RegistrationFormResponse.city"] = { lk: `%${filters.city}%` };
    }
    if (filters.country) {
      apiFilters["RegistrationFormResponse.country"] = {
        lk: `%${filters.country}%`,
      };
    }

    return apiFilters;
  };

  const { response, loading, error } = useAPI<{
    message: string;
    status: boolean;
    data: {
      current_page: number;
      last_page: number;
      total: number;
      per_page: number;
      data: RegisteredUser[];
    };
  }>(
    ENDPOINTS.get_registration,
    true,
    [page, pageSize, search, filters],
    getCall({
      limit: pageSize,
      page: page,
      search: search !== undefined && search ? search : "",
      with: ["order", "RegistrationFormResponse"],
      filter: buildFilters(),
      event_id: event.id,
    }),
  );

  if (error) return <>Something went wrong....</>;

  return (
    <div className="w-full">
      <RegistrationTable
        loading={loading}
        data={response ? response.data : null}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
        setSearch={setSearch}
        search={search}
        filters={filters}
        setFilters={setFilters}
        ticketOptions={ticketOptions}
      />
    </div>
  );
};

export default RegistrationDetails;
